import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  copyMyFile,
  archiveMyFile
} from '../../../../../../../stores/my-files/my-files.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getMyFile } from '../../../../../../../stores/my-files/my-files.selectors'

const mapStateToProps = (state, { id }) => {
  const file = getMyFile(state, id)
  return {
    id: file.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onCopy: () =>
    dispatch(copyMyFile(ownProps.id))
      .then(() => document.location.reload()) // BE include tags are needed to avoid this reload
      .catch(errorHandler),
  onArchive: () => dispatch(archiveMyFile(ownProps.id)).catch(errorHandler)
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContextMenu)
